var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "formulate-simple-select" },
    [
      _c(
        "v-select",
        _vm._b(
          {
            ref: "select",
            class:
              "formulate-input-element formulate-input-element--" +
              _vm.context.type,
            attrs: {
              "data-type": _vm.context.type,
              options: _vm.context.options,
              reduce: function(x) {
                return x.value
              },
              label: "label",
              appendToBody: true,
              calculatePosition: _vm.calculateSelectPostion,
              deselectFromDropdown: true
            },
            scopedSlots: _vm._u([
              {
                key: "selected-option-container",
                fn: function(ref) {
                  var multiple = ref.multiple
                  var option = ref.option
                  return [
                    multiple
                      ? _c("span", { staticClass: "noRender" })
                      : _c(
                          "span",
                          {
                            class:
                              "formulate-input-element--" +
                              _vm.context.type +
                              "__selected"
                          },
                          [_vm._v(_vm._s(option.label))]
                        )
                  ]
                }
              },
              {
                key: "option",
                fn: function(ref) {
                  var label = ref.label
                  return [
                    _c(
                      "div",
                      { staticClass: "formulate-option-selector__option" },
                      [
                        _c("span", { staticClass: "option-label" }, [
                          _vm._v(_vm._s(label))
                        ]),
                        _vm._v(" "),
                        _c("span", {
                          staticClass:
                            "icon icon--check--filled--inverted icon--shakespeare option-check"
                        })
                      ]
                    )
                  ]
                }
              },
              {
                key: "footer",
                fn: function() {
                  return _vm._l(_vm.context.options, function(option) {
                    return _c(
                      "div",
                      {
                        key: option.value,
                        class:
                          "formulate-input-element--" +
                          _vm.context.type +
                          "__ph"
                      },
                      [
                        _vm._v("\n\t\t\t\t" + _vm._s(option.label)),
                        _c("span", {
                          staticClass:
                            "icon icon--check--filled--inverted icon--shakespeare option-check"
                        })
                      ]
                    )
                  })
                },
                proxy: true
              }
            ]),
            model: {
              value: _vm.context.model,
              callback: function($$v) {
                _vm.$set(_vm.context, "model", $$v)
              },
              expression: "context.model"
            }
          },
          "v-select",
          _vm.context.attributes,
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }